import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  withStyles,
  Typography,
  Grid,
} from '@material-ui/core';

export const styles = () => ({
  container: { margin: 5 },
  root: { flexGrow: 1 },
  typeContainer: { maxWidth: 200 },
  control: { padding: 4 },
});

export class EventTemplateInformationCardComponent extends React.Component {
  render() {
    return (
      <Grid container justify="center" className={this.props.classes.container}>
        <Grid item>
          <h3>
            <small>
              Worklows can be used to provide a quick, easy, and consistant way to create Events
            </small>
          </h3>
          <p>
            Workflows are exactly that, a workflow by which you can create events.
            Define common or recurring events (same name, starting status, tags, data fields)
            for your users to select from instead of them selecting all of these items each time they initiate an event.
          </p>

          <h4>Name and Description</h4>
          <div>
            <p>
              The <b>Name</b> of the Workflow is used as the main
              display item of each Event. This name is used when
              the actual Event is created from the workflow.
            </p>
            <br />
            <p>
              The <b>Description</b> of the Workflow is used as
              additional details on the Event being created. This description
              is used when the actual Event is created from the workflow.
            </p>
            <br />
            <Typography gutterBottom variant="caption">
              When creating an Event from an Workflow, users will be able
              to search for the workflow by the name you provide, so make sure it
              is descriptive and easy for your usres to find.
            </Typography>
          </div>

          <h4>Configurations</h4>
          <div>
            <p>
              There are a few configurations you can set on each Workflow
              which will allow it to behave differently than the default functionality
            </p>
            <br />
            <p>
              <b>Duplicates</b>: The duplicate configuration will allow or prevent
              Events created from the same Workflow to have multiple <b>active </b>
              events at the same time. If you do not allow duplicates, you will not be
              able to create another event from that workflow until the current active event
              is first completed.
            </p>
            <br />
            <p>
              <b>Configurable Tags</b>: The Configurable Tags option lets you decide if
              users can change, add, or remove tags for an Event that is created or
              updated from a Workflow. Disabling configurable tags will ensure you
              always have the same tags each time an event is created from the workflow.
              Allowing configurable tags will let users change out tags during creation
              or udpate of Events.
            </p>
          </div>

          <h4>Archiving and Deleting</h4>
          <div>
            <p>
              You can archive or delete Workflows at any time.
              If you no longer wish to use a workflow, or just want to
              temporarily disable events from being created for
              a certain workflow, you can use this feature.
            </p>
            <br />
            <p>
              <b>Archiving</b> does not remove the workflow permanently,
              but instead will hide it from being used in new Event
              creation in the Dashboard. You can always un-archive
              the workflow and bring it back to use.
            </p>
            <br />
            <p>
              <b>Deleting</b> will remove the field permanently,
              and cannot be recovered later.
              <b> Note</b> that you may lose any track and trend
              analytics on the number of Events created using this
              workflow if you perform this action.
            </p>
          </div>

          <h4>APIs and System Integration</h4>
          <div>
            <p>
              Pingum allows any organization to utilize our 3rd Party APIs
              to create and manage events from your own systems. Often organizations
              have an internal system where they initiate Events from. Those organizations
              then use Pingum to manage the Events through completion. Workflows
              offer an easy way for your developers to quickly and easily initiate
              those events from another tool.
            </p>
            <br />
            <p>
              To get started, provide your developers with the <b>developer</b> role in
              Pingum. This role will give those individuals access to our documenation
              and the <b>API Key</b> which gives acceess to your organization&#39;s
              data through our 3rd Pary APIs. All you need from there is the unique
              <b>ID</b> of the Workflow(s) you wish to create from your system.
              Pass that <b>ID</b> along with the API call and we will handle creating
              the event from there.
            </p>
          </div>
        </Grid>
      </Grid>
    );
  }
}

EventTemplateInformationCardComponent.propTypes = { classes: PropTypes.object.isRequired };

export default
connect()(withStyles(styles, { withTheme: true })(EventTemplateInformationCardComponent));
